// test1640
(1640 && 0);
